import AjaxLoad from '../../lib/ajax-load';
import { getOffset, smoothScrollTo } from '../../js/helper';

class FilterBar {
    constructor (element) {
        this.filterBar = null;
        this.filterBarPos = null;
        this.newFilterBarPos = 0;

        this.$siteHeader = document.querySelector('[data-site-header]');

        this.editmode = document.body.getAttribute('data-editmode') === '';
        this.customEvent = new CustomEvent('ajaxload');

        if (element) {
            this.filterBar = element;
        } else {
            this.filterBar = document.querySelector('[data-filterbar="root"]');
        }

        if (this.filterBar) {
            this.filterBarPos = this.filterBar.offsetTop + 2;
            this.filterToggle = document.getElementById('filter-toggle');
            this.filterWrapper = this.filterBar.querySelector('[data-filterbar="wrapper"]');
            this.filterList = this.filterBar.querySelector('[data-filterbar="list"]');
            this.filters = [].slice.call(this.filterBar.querySelectorAll('[data-filterbar="filter"]'));

            // Elements for Ajax Loads
            this.$target = this.filterBar.nextElementSibling.querySelector('[data-teaser-grid="root"]');
            this.$overview = document.querySelector('[data-overview="root"]');

            if (!this.editmode) {
                this.initialize();
            }
        }
    }

    initialize () {
        this.setEvents();

        setTimeout(() => {
            this.checkDomPosition();
        }, 1500);
        this.checkScrollPosition(window.pageYOffset);

        // initial state is always open; we have to set the checkbox to checked with js because
        // on some browsers the cache remembers the input checkbox state
        this.filterToggle.checked = true;
        this.handleToggleState();
    }

    // This is neccesary because of ajaxLoad-Content. It came from an customEvent('ajaxload') by teaser-grid.js
    calculateNewPosition () {
        const filterFixed = this.filterBar.classList.contains('is--fixed');

        if (filterFixed) {
            this.filterBar.classList.remove('is--fixed');
        }

        this.filterBarPos = this.filterBar.offsetTop + 2;

        if (filterFixed) {
            this.filterBar.classList.add('is--fixed');
        }
    }

    setEvents () {
        window.addEventListener('ajaxload', () => {
            this.calculateNewPosition();
        });

        if (this.filterToggle) {
            this.filterToggle.addEventListener('change', () => {
                this.handleToggleState();
            });
        }

        if (this.filters.length > 0) {
            this.filters.forEach((filter) => {
                filter.addEventListener('change', () => {
                    let url = window.location.href.split('?')[0];
                    this.filters.forEach((value, index) => {
                        url += index === 0 ? '?' : '&';
                        url += value.getAttribute('name') + '=' + value.value;
                    });
                    this.loadContent(url, 'GET');
                });
            });
        }

        this.$target.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-filter-reset') !== null) {
                e.preventDefault();
                const url = window.location.href.split('?')[0];
                window.location.href = url;
            }
        });

        // History Event Listener
        window.addEventListener('popstate', (e) => {
            if (e.state !== null) {
                if (e.state.type === 'ajax' || e.state.type === 'initial') {
                    location.replace(window.location.href);
                }
            } else {
                location.replace(window.location.href);
            }
        });
    }

    checkScrollPosition (position) {
        if (!this.editmode) {
            if (this.$siteHeader.classList.contains('is--visible')) {
                if (window.innerWidth < 1024) {
                    this.newFilterBarPos = this.filterBarPos - 60;
                } else {
                    this.newFilterBarPos = this.filterBarPos - 70;
                }
            } else {
                this.newFilterBarPos = this.filterBarPos;
            }

            if (position >= this.newFilterBarPos && !this.filterBar.classList.contains('is--fixed')) {
                this.filterBar.classList.add('is--fixed');
                this.filterBar.nextElementSibling.style.marginTop = this.filterBar.clientHeight + 'px';
            } else if (position < this.newFilterBarPos && this.filterBar.classList.contains('is--fixed')) {
                this.filterBar.classList.remove('is--fixed');
                this.filterBar.nextElementSibling.style.marginTop = '';
            }
        }
    }

    checkDomPosition () {
        if (!this.editmode) {
            if (this.filterBar.classList.contains('is--fixed')) {
                this.filterBar.classList.remove('is--fixed');
            }
            this.filterBarPos = this.filterBar.offsetTop;
        }
    }

    handleToggleState () {
        if (this.filterToggle.checked) {
            this.filterWrapper.style.height = this.filterList.clientHeight + 'px';
            this.filterList.classList.add('is--open');

            setTimeout(() => {
                if (this.filterList.classList.contains('is--open')) {
                    this.filterWrapper.style.height = 'auto';
                }
            }, 500);
        } else {
            this.filterWrapper.style.height = this.filterList.clientHeight + 'px';
            setTimeout(() => {
                this.filterWrapper.style.height = '';
                this.filterList.classList.remove('is--open');
            }, 50);
        }
    }

    loadContent (url, method) {
        this.$overview.classList.add('is--loading');
        smoothScrollTo(0, getOffset(this.$overview).top - 150, 500);

        const ajaxLoad = new AjaxLoad(url, {
            requestMethod: method,
            onSuccess: (resultText) => {
                this.setContent(this.createElementFromHTML(resultText), method, () => {
                    history.pushState({ type: 'ajax' }, null, window.location.href);
                    history.replaceState({ type: 'ajax' }, null, url);
                });
            }
        });

        ajaxLoad.initialize();
    }

    createElementFromHTML (htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        if (div.children.length > 1) {
            const itemsArray = [];
            Array.prototype.push.apply(itemsArray, div.children);
            return itemsArray;
        } else {
            return div.firstChild;
        }
    }

    setContent (resultText, method, callback) {
        this.$target.innerHTML = resultText.innerHTML;

        setTimeout(() => {
            this.$overview.classList.remove('is--loading');
            window.dispatchEvent(this.customEvent);

            if (typeof callback === 'function') {
                callback();
            }

            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$target
                }
            });

            window.dispatchEvent(contentUpdateEvent);
            window.initContent(this.$target);
        }, 1100);
    }
}

export { FilterBar };
